


























































import Vue, { PropType } from 'vue';
import FieldInput from '@/components/form/FieldInput.vue';
import FieldMultipleSelect from '@/components/form/FieldMultipleSelect.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import { EFilterTypeField, TTableColumn } from '@/components/table/types';
import { TDropDownItem, TDropDownList } from '@/types';
import TableService from '@/services/TableService';
import { getTranslate } from '@/helpers/translateHelpers';
import { TTableValuesPayload } from '@/components/table/types';

export default Vue.extend({
  name: 'TableFilterItems',
  components: {
    FieldInput,
    FieldMultipleSelect,
    FieldSelect,
  },

  props: {
    column: {
      type: Object as PropType<TTableColumn>,
      required: true,
      default: null,
    },
    multiple: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    filterTypeFields(): typeof EFilterTypeField {
      return EFilterTypeField;
    },
    currentMultiple(): boolean {
      return this.column?.multiple !== undefined
        ? this.column.multiple
        : this.multiple;
    },
    columnFilterOnceValue(): string | number {
      return this.column?.filterValues?.[0]?.value ?? '';
    },
  },

  methods: {
    getTranslate(path: string): string {
      return getTranslate(path);
    },
    check(value: string) {
      return TableService.checkkItems(this.column, value);
    },
    changeList(item: TDropDownItem) {
      const payload: TTableValuesPayload = TableService.addNewItemsWithMultiple(
        this.column,
        item,
        this.currentMultiple
      );

      this.change(payload);
    },
    changeInput(value: string | number) {
      const dropDownItem: TDropDownItem = {
        label: String(value),
        value: value,
      };
      const payload: TTableValuesPayload = TableService.addNewItemsWithMultiple(
        this.column,
        dropDownItem,
        this.currentMultiple
      );

      this.change(payload);
    },
    changeMultipleSelect(values: TDropDownList) {
      const payload: TTableValuesPayload = {
        field: this.column.field,
        values,
      };

      this.change(payload);
    },
    changeOnceSelect(value: TDropDownItem) {
      let values = [value];

      if (value === null) {
        values = [];
      }

      const payload: TTableValuesPayload = {
        field: this.column.field,
        values,
      };

      this.change(payload);
    },
    change(payload: TTableValuesPayload) {
      this.$emit('change', payload);
    },
  },
});
